export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-Rigged-01.50fb858e.jpg";